(function () {

    "use strict";

    function entityService(configurationService, $q, $rootScope, $http, $resource, URL, fileitemService) {

        var self = this;
        if (!$rootScope.itemsMetadata) {
            $rootScope.itemsMetadata = {};
        }
        if (!$rootScope.itemsMetadataValues) {
            $rootScope.itemsMetadataValues = {};
        }


        if (!$rootScope.metadata) {
            $rootScope.metadata = {};
        }

        self.resource = function (entityName) {
            return entityService(entityName);
        };

        self.loadConfiguracion = function () {

            return configurationService.loadConfiguracion();

        };

        function entityService(entityName) {

            var service = {};
            service.entityName = entityName;

            service.update = function (entity) {

                var defered = $q.defer();
                var promise = defered.promise;

                var promises = [];

                if (entity.length > 1) {
                    angular.forEach(entity, function (item) {
                        var metadatosValue = mapValuesMetadata(item, service.entityName);
                        promises.push(self.resourceMultiMetadatas.update({ idFileContainer: item.idFileContainer }, metadatosValue));

                    });
                    $q.all(promises).then(function () {
                        defered.resolve(entity);

                    }).catch(function (error) {
                        console.log(error);
                        defered.reject(error);
                        $rootScope.activated = false;

                    });

                } else if (entity.length === 1) {
                    var metadatosValue = mapValuesMetadata(entity[0], service.entityName);
                    self.resourceMultiMetadatas.update({ idFileContainer: entity[0].idFileContainer }, metadatosValue,
                        function () {
                            defered.resolve(entity[0]);
                        },
                        function () {
                            defered.reject();
                            $rootScope.activated = false;
                        });
                } else {
                    var metadatosValues = mapValuesMetadata(entity, service.entityName);
                    self.resourceMultiMetadatas.update({ idFileContainer: entity.idFileContainer }, metadatosValues,
                        function () {
                            defered.resolve(entity);
                        },
                        function () {
                            defered.reject();
                            $rootScope.activated = false;
                        });
                }



                return promise;
            };

            service.save = function (entity) {

                var defered = $q.defer();
                var promise = defered.promise;
                var promises = [];
                configurationService.loadConfiguracion()
                    .then(function (data) {
                        var fileContainer = data.fileContainers.find(function (item) {
                            return item.name === entityName;
                        });

                        if (fileContainer != null) {
                            entity = entity.map(function (item) {
                                item.idFileContainer = fileContainer.id;
                                return item;
                            });

                            if (entity.length > 1) {
                                angular.forEach(entity, function (item) {
                                    if (item.idVersion) { item.id = item.idVersion; }
                                    var metadatosValue = mapValuesMetadata(item, service.entityName);
                                    promises.push(fileitemService.onCreateFileItemEvent((item.ficheros != null ? item.ficheros[0] : {}), {}, metadatosValue, fileContainer.id, (item.ficheros == null ? true : false), item.idVersion)
                                        .then(function (data) {
                                            console.log(entity);
                                            item.id = data;
                                        },
                                            function (error) {
                                                console.log(error);
                                                defered.reject(error);
                                                $rootScope.activated = false;
                                            }));
                                });
                                $q.all(promises).then(function () {
                                    defered.resolve(entity);

                                }).catch(function (error) {
                                    console.log(error);
                                    defered.reject(error);
                                    $rootScope.activated = false;

                                });

                            } else if (entity.length === 1) {
                                if (entity[0].idVersion) { entity[0].id = entity[0].idVersion; }
                                var metadatosValue = mapValuesMetadata(entity[0], service.entityName);
                                fileitemService.onCreateFileItemEvent((entity[0].ficheros != null ? entity[0].ficheros[0] : {}), {}, metadatosValue, fileContainer.id, (entity[0].ficheros == null ? true : false), entity[0].idVersion)
                                    .then(function (data) {
                                        entity[0].id = data;
                                        defered.resolve(entity[0]);
                                    },
                                        function (error) {
                                            console.log(error);
                                            defered.reject(error);
                                            $rootScope.activated = false;
                                        });
                            } else {
                                if (entity.idVersion) { entity.id = entity.idVersion; }
                                var metadatosValues = mapValuesMetadata(entity, service.entityName);
                                fileitemService.onCreateFileItemEvent((entity.ficheros != null ? entity.ficheros[0] : {}), {}, metadatosValues, fileContainer.id, (entity.ficheros == null ? true : false), entity.idVersion)
                                    .then(function (data) {
                                        entity.id = data;
                                        defered.resolve(entity);
                                    },
                                        function (error) {
                                            console.log(error);
                                            defered.reject(error);
                                            $rootScope.activated = false;
                                        });
                            }
                        }

                    }, function () {
                        defered.reject();
                    });

                return promise;
            };

            service.remove = function (entity) {

                var defered = $q.defer();
                var promise = defered.promise;

                fileitemService.delete(entity.idFileContainer, entity.id)
                    .then(function () {
                        defered.resolve();
                    })
                    .catch(function () {
                        defered.reject();
                        $rootScope.activated = false;
                    });

                return promise;
            };

            service.getItems = function (filter) {

                var defered = $q.defer();
                var promise = defered.promise;
                if (filter == null) { filter = {}; }
                filter.entityName = service.entityName;
                loadMetadatas(service.entityName).then(function (metadatas) {
                    loadItems(service.entityName, filter).then(function (items) {
                        defered.resolve(mapMetadataValues(metadatas, items));
                    });
                });

                return promise;
            };

            service.getItem = function (id) {

                var defered = $q.defer();
                var promise = defered.promise;
                loadMetadatas(service.entityName).then(function () {
                    loadItem(service.entityName, id).then(function (entity) {
                        loadMetadataValues(entity).then(function (metadatasValues) {
                            $rootScope.itemsMetadataValues[entityName] = metadatasValues;
                            var mapedItem = mapMetadatosValue(service.entityName);
                            var itemFilter = mapedItem.find(function (item) {
                                return item.id === id;
                            });
                            defered.resolve(itemFilter);
                        });
                    });
                });
                return promise;
            };

            service.getMetadatas = function () {

                var defered = $q.defer();
                var promise = defered.promise;
                loadMetadatas(service.entityName).then(function () {
                    defered.resolve($rootScope.metadata[service.entityName]);
                });

                return promise;
            };

            return service;
        }

        function loadMetadatas(entityName) {
            var defered = $q.defer();
            var promise = defered.promise;

            if ($rootScope.metadata[entityName]) {
                defered.resolve($rootScope.metadata[entityName + "_arrayFortmat"]);
            }
            else {
                configurationService.loadConfiguracion()
                    .then(function (data) {
                        var fileContainer = data.fileContainers.find(function (item) {
                            return item.name === entityName;
                        });

                        var itemsConfig;
                        if (fileContainer != null) {
                            itemsConfig = {
                                idFileContainer: fileContainer.id
                            };
                        }

                        self.metadatasFileContainers.methodGet(itemsConfig, {},
                            function (data) {
                                var metadatas = {};
                                data.items.forEach(function (item) {

                                    metadatas[item.internalName] = {
                                        type: item.type,
                                        defaultValue: item.defaultValue,
                                        label: item.nameToShow,
                                        isRequired: item.isRequired,
                                        idMetadata: item.id,
                                        internalName: item.internalName,
                                        idValueList: item.idValueList,
                                        idType: item.idType
                                    };
                                });
                                $rootScope.metadata[entityName] = metadatas;
                                $rootScope.metadata[entityName + "_arrayFortmat"] = data.items;
                                defered.resolve(data.items);

                            }, function (error) {
                                console.log(error);
                                defered.reject();
                                $rootScope.activated = false;

                            });
                    }, function () {
                        defered.reject();
                    });
            }

            return promise;
        }

        function loadItem(entityName, id) {
            var defered = $q.defer();
            var promise = defered.promise;

            configurationService.loadConfiguracion()
                .then(function (data) {

                    var fileContainer = data.fileContainers.find(function (item) {
                        return item.name === (entityName);
                    });

                    var itemsConfig;
                    if (fileContainer != null) {
                        itemsConfig = {
                            idFileContainer: fileContainer.id,
                            idFileItem: id
                        };
                    }

                    self.fileContainerItem.methodGet(itemsConfig, {},
                        function (data) {
                            $rootScope.itemsMetadata[entityName] = [data];
                            defered.resolve(data);

                        }, function (error) {
                            defered.reject();
                            console.log(error);
                            $rootScope.activated = false;
                        });

                }, function () {
                    defered.reject();
                });

            return promise;
        }

        function loadItems(entityName, entityFilter) {
            var defered = $q.defer();
            var promise = defered.promise;

            configurationService.loadConfiguracion()
                .then(function (data) {
                    var fileContainer = data.fileContainers.find(function (item) {
                        return item.name === entityName;
                    });

                    var itemsConfig;
                    if (fileContainer != null) {
                        itemsConfig = {
                            idFileContainer: fileContainer.id
                        };

                    }

                    var solpheoSerachFilter = getSolpheoSearchFilter(entityName, entityFilter);
                    var hasfilter = entityFilter.filtro.length > 0;
                    if (hasfilter) {
                        self.fileItemsFilter.search(itemsConfig, solpheoSerachFilter.filtro,
                            function (data) {
                                defered.resolve(data);

                            }, function (error) {
                                defered.reject();
                                console.log(error);
                                $rootScope.activated = false;
                            });
                    }
                    else {
                        self.fileItems.search(itemsConfig, solpheoSerachFilter.filtro,
                            function (data) {
                                defered.resolve(data);

                            }, function (error) {
                                defered.reject();
                                console.log(error);
                                $rootScope.activated = false;
                            });
                    }
                }, function () {
                    defered.reject();
                });

            return promise;
        }

        function getSolpheoSearchFilter(entityName, entityFilter) {
            entityFilter.filtro = entityFilter.filtro ? entityFilter.filtro : [];
            var metadatas = $rootScope.metadata[entityName];
            entityFilter.filtro.forEach(function (item) {
                if (item.leftOperator.id != null) {
                    var metadata = metadatas[item.leftOperator.id];
                    if (metadata != null) {
                        item.leftOperator.id = metadata.idMetadata;
                        switch (metadata.type) {
                            case "Text":
                                item.leftOperator.idType = 1;
                                break;
                            case "Numerico":
                                item.leftOperator.idType = 2;
                                break;
                            case "Decimal":
                                item.leftOperator.idType = 3;
                                break;
                            case "DateTime":
                                item.leftOperator.idType = 6;
                                break;
                            case "ValueBit":
                                item.leftOperator.idType = 7;
                                break;
                        }
                    }

                }
            });
            return entityFilter;
        }

        function loadMetadataValues(entity) {
            var defered = $q.defer();
            var promise = defered.promise;

            var itemsConfig = {
                idFileContainer: entity.idFileContainer,
                idFileItem: entity.id
            };

            self.fileContainerMetadataValue.methodGet(itemsConfig, {},
                function (data) {
                    defered.resolve(data.items);
                }, function (error) {
                    console.log(error);
                    defered.reject();
                    $rootScope.activated = false;
                });

            return promise;
        }

        function mapValuesMetadata(itemsSave, entityName) {
            var metadatasSave = [];
            var metadatas = $rootScope.metadata[entityName];
            var metadatasArray = Object.values(metadatas);

            metadatasArray.forEach(function (metadata) {
                var metadatas = getValuesMetadatas(itemsSave, metadata);
                if (metadatas != null) { metadatasSave.push(metadatas); }
            });
            return metadatasSave; 

        }

        function getValuesMetadatas(itemsSave, metadata) {

            var itemObject = {
                "idMetadata": metadata.idMetadata,
                "idFileItem": (itemsSave.id != null ? itemsSave.id : 0),
                "stringValue": null,
                "intValue": null,
                "decimalValue": null,
                "dateTimeValue": null,
                "valueBit": null,
                "idType": metadata.idType
            };

            switch (metadata.type) {
                case "Text":
                    itemObject["stringValue"] = itemsSave[metadata.internalName];
                    break;
                case "Numerico":
                    itemObject["intValue"] = itemsSave[metadata.internalName];
                    break;
                case "Decimal":
                    itemObject["decimalValue"] = itemsSave[metadata.internalName];
                    break;
                case "DateTime":
                    itemObject["dateTimeValue"] = itemsSave[metadata.internalName];
                    break;
                case "DateHora":
                    itemObject["dateTimeValue"] = itemsSave[metadata.internalName];
                    break;
                case "Date":
                    itemObject["dateTimeValue"] = itemsSave[metadata.internalName];
                    break;
                case "Binario":
                    itemObject["valueBit"] = itemsSave[metadata.internalName];
                    break;


            }
            return itemObject;

        }

        function mapMetadatosValue(entityName) {
            var items = $rootScope.itemsMetadata[entityName];
            var metadatas = $rootScope.metadata[entityName];
            var metadatasArray = Object.values(metadatas);
            var itemsMapeados = items.map(function (item) {

                metadatasArray.forEach(function (metadata) {
                    item[metadata.internalName] = getMetadataValue(item.id, metadata.idMetadata, entityName);
                });
                return item;

            });

            return itemsMapeados;
        }

        function mapMetadataValues(metadatas, items) {

            var files = items.rows.map(function (file) {
                metadatas.forEach(function (metadata) {
                    file[metadata.internalName] = file.values[adaptedName(metadata.nameToShow)];
                });

                return file;

            });

            return files;
        }

        function adaptedName(name) {
            return name.toLowerCase();
        }

        function getMetadataValue(idFileItem, idMetadata, entityName) {
            var metadataValues = $rootScope.itemsMetadataValues[entityName];
            var metadataValue = metadataValues.find(function (itemvalue) {
                return (itemvalue.idFileItem == idFileItem && itemvalue.idMetadata == idMetadata);
            });
            if (!metadataValue) {
                return null;
            }

            switch (metadataValue.idType) {
                case 1:
                    return metadataValue.stringValue;
                case 2:
                    return metadataValue.intValue;
                case 3:
                    return metadataValue.decimalValue;
                case 4:
                    return metadataValue.dateTimeValue;
                case 5:
                    return metadataValue.dateTimeValue;
                case 6:
                    return metadataValue.dateTimeValue;
                case 7:
                    return metadataValue.valueBit;
            }
        }

        self.metadatasFileContainers = $resource(URL.URL + '/api/metadatas/filecontainers/:idFileContainer?pageIndex=0&pageSize=10000000', { idFileContainer: '@_idFileContainer' }, {
            methodGet: {
                method: 'GET'
            }
        });

        self.fileContainerItems = $resource(URL.URL + '/api/fileitems/:idFileContainer?pageIndex=0&pageSize=10000000', { idFileContainer: '@_idFileContainer' }, {
            methodGet: {
                method: 'GET'
            }
        });

        self.fileContainerItem = $resource(URL.URL + '/api/fileitems/:idFileContainer/:idFileItem', { idFileContainer: '@_idFileContainer', idFileItem: '@_idFileItem' }, {
            methodGet: {
                method: 'GET'
            }
        });

        self.fileContainerMetadataValue = $resource(URL.URL + '/api/filecontainersmetadatasvalues/:idFileContainer', {
        }, {
                methodGet: {
                    method: 'GET'
                }
            });

        self.resourceMultiMetadatas = $resource(URL.URL + '/api/filecontainersmetadatasvalues/:idFileContainer', { idFileContainer: '@_idFileContainer' }, {
            update: {
                method: 'PUT'
            },
            queryPaged: {
                method: 'GET'
            }
        });

        self.fileItems = $resource(URL.URL + '/api/fileitems/table/:idFileContainer?pageIndex=0&pageSize=100000000&sortColumn=CreatedDate&sortOrder=desc', { idFileContainer: '@_idFileContainer' }, {
            search: {
                method: 'POST'
            }
        });

        self.fileItemsFilter = $resource(URL.URL + '/api/fileitems/table/search/advanced/:idFileContainer?pageIndex=0&pageSize=100000000&sortColumn=CreatedDate&sortOrder=desc', { idFileContainer: '@_idFileContainer' }, {
            search: {
                method: 'POST'
            }
        });
    }

    entityService.$inject = ["solpheo.configurationService", "$q", "$rootScope", "$http", "$resource", "URL", "solpheo.fileitemService"];

    angular.module("solpheo").service("solpheo.entityService", entityService);

})();


